import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { MovimentacoesExtrato } from '@/pages/movimentacoes-extrato';
import { StringToIdpkSchema } from '@/std/schema';

const ParamsSchema = z.object({ idpk: StringToIdpkSchema });

export const Route = createFileRoute('/a/movimentacoes/extrato/$idpk')({
    component: Component,
    params: {
        parse: (params) => {
            const result = ParamsSchema.safeParse(params);

            return result.success ? result.data : false;
        },
    },
});

function Component() {
    const { idpk } = Route.useParams();

    return <MovimentacoesExtrato idpk={idpk} />;
}
